export default "__VITE_ASSET__CHETUYtk__"